import { isNil } from 'ramda'

const hasAccess = (accessObj, path) => {
  const accessLevel = accessObj[path]

  return !isNil(accessLevel)
}

export { hasAccess }
